export default __webpack_public_path__ + "static/media/Project-2-Music-World-Ecommerce.345ea392.png";